/* eslint-disable no-undef */
const _rdt = (...args) => {
  if (typeof rdt !== 'function') {
    return;
  }

  rdt(...args);
};

export default {
  Wetransfer_site_visit() {
    _rdt('track', 'PageVisit');
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_Plus_Button_Conversion() {
    _rdt('track', 'AddToWishlist');
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion() {
    _rdt('track', 'SignUp');
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion() {
    _rdt('track', 'SignUp');
  },
  WeTransfer_Got_Plus() {
    _rdt('track', 'AddToWishlist');
  },
  WeTransfer_Plus_Homepage_Visit() {
    _rdt('track', 'ViewContent');
  },
  WeTransfer_Sign_Me_Up_Button_Conversion() {
    _rdt('track', 'AddToCart');
  },
  WeTransfer_Get_Plus_Conversion() {
    _rdt('track', 'AddToCart');
  },
  WeTransfer_More_About_Plus_Button_Conversion() {
    _rdt('track', 'AddToCart');
  },
  WT_Plus_Add_Payment_Conv() {
    _rdt('track', 'Purchase');
  },
  Wetransfer_Plus_Complete_Order_Conv() {
    _rdt('track', 'Purchase');
  },
  WeTransfer_Plus_Confirmation_Page_Conversion() {
    _rdt('track', 'Search');
  },
};
